<template>
  <div class="d-flex flex-row align-items-stretch">
    <div
      class="client-card border flex-grow-1"
      :class="[statusUi.cardClass, displayVariant === 'wide' ? 'client-card--bpm-wide' : '']"
    >
      <template v-if="displayVariant === 'default'">
        <div class="flex-grow-1 min-w-0">
          <div class="client-card__panel">
            <i v-if="statusUi.kind === 'waiting'" class="ki-duotone ki-information fs-3x text-warning">
              <i class="path1"></i>
              <i class="path2"></i>
              <i class="path3"></i>
            </i>
            <i v-else-if="statusUi.kind === 'fatal_error'" class="ki-duotone ki-shield-cross fs-3x text-danger">
              <i class="path1"></i>
              <i class="path2"></i>
              <i class="path3"></i>
            </i>
            <div
              v-else-if="statusUi.kind === 'in_progress'"
              class="d-flex align-items-center justify-content-center client-card__icon-loader"
            >
              <i class="ki-duotone ki-abstract-33 fs-3x text-primary verified">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </div>
            <div class="ms-4">
              <div
                class="fs-6 fw-bolder text-gray-700 line-clamp"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
              >{{ statusNameUi }}</div>
              <div class="fs-8 text-gray-400">
                <span v-if="this.module.Modal.infoCard('iin')">
                  {{ formattedIin }} /
                </span>
                <span v-if="this.module.Modal.infoCard('person')" class="text-primary opacity-75">{{ personTypeLabel }}</span> /
                <span v-if="this.module.Modal.infoCard('resident')" class="text-danger opacity-75">{{ residentTypeLabel }}</span>
              </div>
            </div>
            <div class="card_change" v-if="!changeDisabled">
              <slot name="change"></slot>
            </div>
          </div>
          <slot name="footer" v-if="!changeDisabled"></slot>
        </div>
      </template>

      <template v-else-if="displayVariant === 'wide'">
        <div class="client-card__panel client-card__panel--wide flex-grow-1 min-w-0">
          <div class="client-card__icon">
            <i v-if="statusUi.kind === 'waiting'" class="ki-duotone ki-information fs-3x text-warning">
              <i class="path1"></i>
              <i class="path2"></i>
              <i class="path3"></i>
            </i>
            <i v-else-if="statusUi.kind === 'fatal_error'" class="ki-duotone ki-shield-cross fs-3x text-danger">
              <i class="path1"></i>
              <i class="path2"></i>
              <i class="path3"></i>
            </i>
            <div
              v-else-if="statusUi.kind === 'in_progress'"
              class="d-flex align-items-center justify-content-center client-card__icon-loader"
            >
              <i class="ki-duotone ki-abstract-33 fs-3x text-primary verified">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </div>
          </div>
          <div
            class="client-card__title fs-6 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
          >{{ statusNameUi }}</div>
          <div class="client-card__meta fs-8 text-gray-400">
            <span v-if="this.module.Modal.infoCard('iin')">
              {{ formattedIin }} /
            </span>
            <span v-if="this.module.Modal.infoCard('person')" class="text-primary opacity-75">{{ personTypeLabel }}</span> /
            <span v-if="this.module.Modal.infoCard('resident')" class="text-danger opacity-75">{{ residentTypeLabel }}</span>
          </div>
          <div v-if="!changeDisabled" class="client-card__extras">
            <slot name="footer"></slot>
          </div>
          <div v-if="!changeDisabled" class="client-card__actions card_change">
            <slot name="change"></slot>
          </div>
        </div>
      </template>
    </div>

    <div class="d-flex" style="margin-bottom: 10px;">
      <div v-if="statusUi.showNextAction" class="ms-1 flex-grow-1">
        <a
          class="w-100 h-100 btn btn-outline-success client-card border border-success d-flex align-items-center justify-content-center hover-text-white"
          @click="nextAction()"
        >
          <span class="fs-7 text-success d-none d-md-inline">
            Далее
          </span>
          <i class="ki-outline ki-right-square fs-3 text-success d-md-none"></i>
        </a>
      </div>
      <div v-if="statusUi.showStartAction" class="ms-1 flex-grow-1">
        <a
          class="w-100 h-100 btn btn-outline-success client-card border border-success d-flex align-items-center justify-content-center hover-text-white"
          @click="startAction()"
        >
          <span class="fs-7 text-success d-none d-md-inline">
            Подтвердить
          </span>
          <i class="ki-outline ki-check-circle fs-3 text-success d-md-none"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerBpmEmptyCard',
  props: {
    data: {
      type: Object,
      default: () => ({
        filter: {
          resident: true,
          person: true,
        },
        search: {
          phone: '7',
          iin: '',
          nomer_vu: '',
          isPdl: false,
          isSocial: false,
        }
      })
    },
    clientType: {
      type: Number,
      default: 0 // 0 - Страхователь, 1 - Водитель
    },
    statusName: {
      type: String,
      default: 'Поиск клиента...'
    },
    statusCode: {
      type: String,
      default: 'init'
    },
    status: {
      type: String,
      default: '0' // 0 - Ожидание, 1 - Процесс, 2 - Успешно, 3 - Ошибка, 9 - Финальная ошибка, 10 - Финальный успех
    },
    bpStatus: {
      type: Number,
      default: 0 // 0 - Ожидание, 1 - Готов к запуску, 2 - Запущен, 3 - Завершен
    },
    changeDisabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'wide'].includes(value)
    },
    module: {
      type: Function,
      required: true
    },
    mode: {
      type: [Object, Function],
      required: true
    },
  },
  emits: ['start-action', 'next-action'],
  data() {
    return {
      isMobileViewport: false
    }
  },
  computed: {
    displayVariant() {
      if (this.variant === 'wide' && this.isMobileViewport) {
        return 'default'
      }
      return this.variant
    },
    normalizedStatus() {
      return String(this.status)
    },
    isWaitingStatus() {
      return this.normalizedStatus === 'WAITING_USER'
    },
    isFailedStatus() {
      return ['FAILED', 'TIME_OUT', 'TIMED_OUT'].includes(this.normalizedStatus)
    },
    isCompletedStatus() {
      return this.normalizedStatus === 'COMPLETED'
    },
    statusUi() {
      if (this.bpStatus === 0) {
        return { kind: 'waiting', cardClass: 'border-warning', showNextAction: false, showStartAction: true }
      }
      if (this.isWaitingStatus) {
        return { kind: 'waiting', cardClass: 'border-warning', showNextAction: true, showStartAction: false }
      }
      if (this.isFailedStatus || !this.data.filter.resident) {
        return { kind: 'fatal_error', cardClass: 'border-danger', showNextAction: false, showStartAction: false }
      }
      if (this.isCompletedStatus) {
        return { kind: 'done', cardClass: '', showNextAction: false, showStartAction: false }
      }
      return { kind: 'in_progress', cardClass: 'pulse pulse-success', showNextAction: false, showStartAction: false }
    },
    statusNameUi() {
      if (this.data.title && this.bpStatus === 0) {
        return this.data.title
      }
      return this.statusName
    },
    formattedIin() {
      const iin = this.data?.search?.iin || ''
      const digitsOnly = String(iin).replace(/\s+/g, '')
      return digitsOnly.replace(/(.{3})/g, '$1 ').trim()
    },
    personTypeLabel() {
      const isPerson = this.data?.filter?.person
      if (this.isMobileViewport) {
        return isPerson ? 'ФЛ' : 'ЮЛ'
      }
      return isPerson ? 'Физ. лицо' : 'Юр. лицо'
    },
    residentTypeLabel() {
      const isResident = this.data?.filter?.resident
      if (this.isMobileViewport) {
        return isResident ? 'Рез.' : 'Нерез.'
      }
      return isResident ? 'Резидент' : 'Нерезидент'
    }
  },
  mounted() {
    this.mobileMediaQuery = window.matchMedia('(max-width: 767.98px)')
    this.isMobileViewport = this.mobileMediaQuery.matches
    this.onMobileViewportChange = (event) => {
      this.isMobileViewport = event.matches
    }
    this.mobileMediaQuery.addEventListener('change', this.onMobileViewportChange)
  },
  beforeUnmount() {
    this.mobileMediaQuery?.removeEventListener('change', this.onMobileViewportChange)
  },
  methods: {
    startAction() {
      this.$emit('start-action', this.data.id)
    },
    nextAction() {
      this.$emit('next-action', this.data.id)
    }
  }
}
</script>

<style scoped>
.hover-text-white:hover > span,
.hover-text-white:hover > i {
  color: #fff !important;
}
</style>
